import { Button } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import type { KeyboardEventHandler } from "react";
import { useFormsContext } from "../../context/FormsContext";
import { SearchFilter } from "./searchFilter";

type Props = {
	searchForms: Function;
};

export const Filters = ({ searchForms }: Props) => {
	const {
		actions: { setSearchText },
	} = useFormsContext();

	const onKeyDown: KeyboardEventHandler<HTMLDivElement> = (e) => {
		if (e.key === "Enter") {
			searchForms();
		}
	};

	const resetFilter = () => {
		setSearchText("");
		searchForms();
	};

	return (
		<Grid2 container spacing={2} alignItems="center">
			<Grid2 size={{ xs: 12, md: 10 }}>
				<SearchFilter onKeyDown={onKeyDown} />
			</Grid2>
			<Grid2 size={{ xs: 12, md: 2 }}>
				<Button
					fullWidth
					variant="contained"
					color="inherit"
					onClick={resetFilter}
				>
					RESET
				</Button>
			</Grid2>
		</Grid2>
	);
};
